import React, { useState, useEffect } from "react";
import { AppBar, Typography, Box, Button } from "@mui/material";
import logo from "../../assets/images/logo.svg";
import { signOut } from "aws-amplify/auth";
import { getAuthenticatedUser } from "../../utils/Auth";
import { useLocation } from "react-router-dom";
import { useManagerUser } from "./ManagerUserContext";

function Header() {
  const location = useLocation();
  const testPage = location.pathname;
  const isManagerPage = testPage.startsWith("/manager");
  const [user, setUserId] = useState("");
  const { adminUser } = useManagerUser();
  const adminUserName = adminUser?.admin_user_name || "";

  // 表示しているページパスを取得
  useEffect(() => {
    const fetchAuthSession = async () => {
      try {
        const { userId } = await getAuthenticatedUser();
        if (userId) {
          setUserId(userId);
        }
      } catch (err) {
        console.error("fetchAuthSession:", err);
      }
    };
    fetchAuthSession();
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
      window.location.href = "/login";
    } catch (err) {
      console.error("ログアウト失敗:", err);
    }
  };

  return (
    <AppBar
      position="static"
      sx={{
        height: "80px", // AppBarの高さを指定
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: "0 30px",
          padding: { xs: "0 6px", md: "0 30px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            position: "relative", // ロゴとボタンを絶対位置で配置
          }}
        >
          {/* ロゴ */}
          <Box
            sx={{
              position: "absolute",
              left: 0, // 左端に配置
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Box
              component="img"
              src={logo}
              alt="Logo"
              sx={{
                width: { xs: 96, sm: 120, md: 140 },
                height: { xs: 56, sm: 80, md: 100 },
                objectFit: "contain",
              }}
            />
          </Box>

          {/* 中央の見出し */}
          <Typography
            variant="h3"
            component="h3"
            fontFamily="Impact"
            sx={{
              flexGrow: 1,
              textAlign: "center",
              fontSize: { xs: '40px' },
            }}
          >
            E-SuiTe
            <Typography
              variant="subtitle2"
              component="div"
              sx={{ fontSize: "12px", mt: "0px" }}   // 少し行間を調整
            >
              Created by freeks Inc.
            </Typography>
          </Typography>

          {/* ログアウトボタン 
          ログインしている場合に表示*/}
          <Box
            sx={{
              position: "absolute",
              right: 0, // 右端に配置
              display: "flex",
              alignItems: "center",
              height: "100%",
            }}
          >
            {user && testPage !== "/" ? (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: { xs: 0.5, sm: 1 },
                }}
              >
                {isManagerPage && adminUserName && (
                  <Typography
                    color="inherit"
                    sx={{
                      fontSize: { xs: 11, sm: 13, md: 14 },
                      maxWidth: { xs: 96, sm: 140, md: 180 },
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={adminUserName}
                  >
                    {adminUserName}
                  </Typography>
                )}
                <Button
                  color="inherit"
                  onClick={handleSignOut}
                  sx={{
                    fontSize: { xs: 12, sm: 14, md: 16 },
                    px: { xs: 1, sm: 1.5, md: 2 },
                    minWidth: { xs: 64, sm: 80, md: 96 },
                    lineHeight: 1.2,
                  }}
                >
                  Logout
                </Button>
              </Box>
            ) : null}
          </Box>
        </Box>
      </Box>
    </AppBar>
  );
}

export default Header;
